import { Component, Input, NgZone, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { SummaryComponent } from '../summary/summary.component';
import { FormService } from '../service';
import { DynamicScriptLoaderService } from '../../../../../../../services/dynamicScriptLoader.service';

import { MatStepper } from '@angular/material/stepper';
import { TranslocoModule } from '@jsverse/transloco';
import { TopNavbarComponent } from '../../../../../components/top-navbar/top-navbar.component';
import { Router } from '@angular/router';
import { BookingConfigService } from '../../../../../../../parkifly-bookings/services/booking-config.service';
import { MatIconModule } from '@angular/material/icon';
import { CartService } from '../../../../../../../parkifly-bookings/services/cart.service';
import { CheckoutServices } from '../../../../../../../parkifly-bookings/services/checkout.service';
import { Subject, takeUntil } from 'rxjs';

declare var payex: any;
@Component({
  selector: 'app-payment',
  imports: [
    SummaryComponent,
    TranslocoModule,
    TopNavbarComponent,
    MatIconModule
],
  providers: [DynamicScriptLoaderService],
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    'style': 'font-family: Inter, sans-serif;'
  }
})

export class PaymentComponent implements OnInit, OnDestroy {
  isLoading: boolean = false;
  payexCreditcardUrl = '';
  payexSwishUrl = '';
  payexUrl = '';
  payexSwishLoaded = false;
  selectedPayment: string | null = null;
  @Input() stepper: MatStepper | null = null;
  @Input() orderId: any = '';
  site: any;
  targetTime: number = 0;
  countdown: number = 0;
  timerInterval: any;
  private destroy$ = new Subject<void>();

  constructor(
    private _formService: FormService,
    private dynamicScriptLoaderService: DynamicScriptLoaderService,
    private ngZone: NgZone,
    private router: Router,
    private bookingConfigService: BookingConfigService,
    private cartService: CartService,
    public checkoutService: CheckoutServices

  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
  }

  toggleSwish() {
    this.selectedPayment == 'swish' ? this.selectedPayment = null : this.selectedPayment = 'swish';
  }

  toggleCredit() {
    this.selectedPayment == 'credit' ? this.selectedPayment = null : this.selectedPayment = 'credit';
  }

  ngOnInit(): void {
    this._formService.paymentReference$
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (reference) => {
          if (reference !== null) {
            this.loadScripts(reference);
            this.startTimer();
          } else {
            this.resetTimer();
            reference = [];
            this.payexCreditcardUrl = null;
            this.payexSwishUrl = null;
            this.selectedPayment = null;
          }
        }
      );
  }

  private loadScripts(paymentReference: any) {
    const cardModal = document.getElementById('swedbank-pay-seamless-view-page');
    if (cardModal) {
      cardModal.innerHTML = ''; cardModal
    }
    const viewCheckoutOp = paymentReference.operations.find(
      (op) => op.rel === 'view-checkout'
    );
    this.payexUrl = viewCheckoutOp?.href;
    this.dynamicScriptLoaderService.addScript(this.payexUrl);

    this.dynamicScriptLoaderService
      .load(this.payexUrl)
      .then(() => {
        payex.hostedView
          .checkout({
            container: 'swedbank-pay-seamless-view-page',
            onPaymentCompleted: (event: any) => {
              this.ngZone.run(() => {
                this._formService.isPaymentCompleted = true;
                this.resetTimer();
                // this.getOrder();
              });
            },
            onPaymentCancelled: (event: any) => {
              this.ngZone.run(() => {
                this.selectedPayment = null;
              });
            }
          })
          .open();
        
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 500);
      })
      .catch(error => console.error(error));
  }

  // Timer
  startTimer() {
    const now = Date.now();
    this.targetTime = now + 15 * 60 * 1000;
    this.timerInterval = setInterval(() => {
      const now = Date.now();
      this.countdown = Math.max(0, Math.floor((this.targetTime - now) / 1000));
      if (this.countdown <= 0) {
        clearInterval(this.timerInterval);
        this.expireSession();
      }
    }, 1000);
  }

  resetTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.countdown = 0;
    this.targetTime = 0;
  }

  expireSession() {
    this.selectedPayment = null;
    if (navigator.onLine && this.orderId) {
      this.cancelOrder();
    } else {
      window.addEventListener('online', this.retryCancelOrder);
    }
    this.router.navigate(['parkifly', this.site]);
  }

  formatTime(seconds: number): string {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  }

  cancelOrder() {
    this.cartService.abortorder(this.orderId).subscribe({
      next: (result) => {
        if (result == true) {
          this.orderId = null;
          this._formService.paymentReference = null;
        }
      },
      error: (err) => {
        console.error('Error occurred while fetching order details:', err);
      },
      complete: () => {
      }
    });
  }

  getOrder() {
    this.checkoutService.getOrder(this.orderId).subscribe(order => {
      const orderNr = order.orderNr;
      const email = order.customer.email;
      if (orderNr != null && email != null) {
        this.router.navigate(['/parkifly/booking-overview', { email: email, booking_number: orderNr }]);
      }
    });
  }

  retryCancelOrder = () => {
    if (this.orderId) {
      setTimeout(() => {
        this.cancelOrder();
        window.removeEventListener('online', this.retryCancelOrder);
      }, 5000);
    }
  };

  goBack() {
    this.stepper?.previous();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
